import { useDispatch, useSelector } from 'react-redux';
import cls from './GameEnd.module.scss';
import { ContentGameEnd } from './assets';
import { RootState } from '../../shared/redux/store';
import nextButtonImg from '../../shared/assets/images/next-button.svg';
import { nextLevel } from '../../shared/redux/game/slice';
import { setPage } from '../../shared/redux/page/slice';
import { Pages } from '../../shared/redux/page/types';
import { sounds } from '../../shared/ui/Sound/assets';

export const GameEnd = () => {
  const dispatch = useDispatch();
  const isSound = useSelector((state: RootState) => state.page.isSound);
  const currentLevel = useSelector((state: RootState) => state.game.currentLevel);
  // useEffect(() => {
  //   if (isSound) {
  //     sounds.fanfare.play();
  //   }
  // }, []);
  return (
    <div className={`${ContentGameEnd[currentLevel - 1].cls} ${cls.GameEnd} page-container`}>
      <div className={cls.blur}></div>
      <div className={cls.background}>
        <img src={ContentGameEnd[currentLevel - 1].captain} alt="Captain" className={cls.captain} />
        <img
          src={ContentGameEnd[currentLevel - 1].traveler}
          alt="Traveler"
          className={cls.traveler}
        />

        <div className="text-container" style={{ top: '23%' }}>
          <p className="text-bg-p">{ContentGameEnd[currentLevel - 1].text}</p>
          <p>{ContentGameEnd[currentLevel - 1].text}</p>
        </div>
        <img
          alt="Next button"
          src={nextButtonImg}
          className={cls.buttonNext}
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }
            if (currentLevel === 3) {
              dispatch(setPage(Pages.FINAL));
            } else {
              dispatch(nextLevel());
            }
          }}
        />
      </div>
    </div>
  );
};
